import {
  Box,
  Button,
  Flex,
  HStack,
  ListItem,
  SlideFade,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import VideoBlock from 'components/VideoBlock';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  videoUrl: string;
  title: string;
  subtitle: string;
  descriptionList: (
    | string
    | {
        key: string;
        values: Record<string, string>;
      }
  )[];
  onContinue: () => void;
  animIndex: number;
};

const ChoiceContainer = ({
  videoUrl,
  title,
  subtitle,
  descriptionList,
  onContinue,
  animIndex,
}: Props) => {
  const { t } = useTranslation();
  return (
    <SlideFade
      in
      offsetX="100px"
      offsetY="0px"
      style={{ width: '100%', maxWidth: '600px' }}
      transition={{ enter: { delay: 0.1 + 0.3 * animIndex } }}
    >
      <Flex
        h={{ base: 'auto', lg: 'full' }}
        width="100%"
        paddingY="20px"
        flexDir="column"
        overflow="hidden"
        borderRadius="10px"
        background="white"
        border="2px solid transparent"
        _hover={{
          border: '2px solid',
          borderColor: 'secondaryColor',
        }}
        boxShadow="0 0 10px 5px rgba(0, 0, 0, 0.05)"
        justifyContent="center"
        alignItems="center"
        cursor="pointer"
        onClick={onContinue}
      >
        {/* {children} */}
        <HStack height="100%" w="full" paddingTop="50px" pr="20px">
          <Flex
            flexDir="column"
            background="transparent"
            width={{ base: '40%', md: '45%' }}
          >
            <Box alignItems="left" justifyContent="left">
              <VideoBlock
                loop
                videoPosition="left"
                videoUrl={videoUrl}
                height={{ base: '150px', md: '250px' }}
              />
            </Box>
          </Flex>
          <Flex
            height="100%"
            width="max-content"
            flexDir="column"
            background="transparent"
            position="relative"
            top="-30px"
          >
            <Flex flexDir="column">
              <Text
                fontSize={{ base: '22px', md: '36px' }}
                color="primaryColor"
                fontWeight="bold"
              >
                {title}
              </Text>
              <Text fontSize="18px" color="primaryColor" marginTop="-10px">
                {subtitle}
              </Text>
            </Flex>
            <Flex flexDir="column" background="transparent" height="100%">
              <UnorderedList
                display="flex"
                flexDir="column"
                height="100%"
                alignItems="left"
                fontSize={{ base: '14px', md: '18px' }}
                justifyContent="center"
                gap={{ md: '20px' }}
                marginTop={{ base: '5px', md: '20px' }}
              >
                {descriptionList.map((description) => {
                  const key =
                    typeof description === 'string'
                      ? description
                      : description.key;
                  const values =
                    typeof description === 'string' ? {} : description.values;
                  return (
                    <ListItem key={key}>
                      <Trans
                        i18nKey={key}
                        components={{ bold: <b /> }}
                        values={values}
                      />
                    </ListItem>
                  );
                })}
              </UnorderedList>
            </Flex>
            {/* <Button
            variant="reno"
            maxWidth="60%"
            flexGrow={1}
            size="lg"
            onClick={onContinue}
            // marginX="50px"
            marginBottom="10px"
            marginTop={{ base: '10px', md: '20px' }}
          >
            {t('common.continue')}
          </Button> */}
          </Flex>
        </HStack>
        <Button
          variant="reno"
          maxWidth={{ base: '60%', md: '40%' }}
          flexGrow={1}
          size="lg"
          onClick={onContinue}
          marginX="50px"
          marginBottom="10px"
          marginTop={{ md: '-20 px' }}
          marginLeft={{ md: '140px' }}
        >
          {t('common.continue')}
        </Button>
      </Flex>
    </SlideFade>
  );
};

export default ChoiceContainer;
